import {
  ClientListQuery,
  darkenHexColor,
  DataGridColumn,
  letterToColorfulHex, lightenHexColor,
  TagsView
} from '../../shared';
import { Avatar, Box, Link as MuiLink, Stack } from '@mui/material';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { getRoute } from '../../app/router';
import { formatToPhoneNumber } from '@coverright/ui/inputs';
import { Check, X } from '@phosphor-icons/react';
import { StatusView } from '../status-filter';
import moment from 'moment/moment';
import * as React from 'react';
import { ClientListTimer } from './client-list-timer';
import { getAgeByBirthdate, getUserName } from '@coverright/utils';
import { Field, StatusDto } from '@coverright/data-access/types/enrollment';

export const clientColumns: DataGridColumn<ClientListQuery['clientViews']['data'][0], Field>[] = [
  {
    title: 'Name',
    value: v => (
      <Stack direction={'row'} alignItems={'center'} gap={1}>
        <Avatar sx={{ bgcolor: lightenHexColor(letterToColorfulHex(v.email || getUserName(v)), 50),
          border: `1px solid ${darkenHexColor(letterToColorfulHex(v.email || getUserName(v)), 10)}`,
          color: darkenHexColor(letterToColorfulHex(v.email || getUserName(v)), 70), width: 20, height: 20, fontSize: 12 }}>
          {v.firstName && _.toUpper(v.firstName[0])}
        </Avatar>
        <MuiLink component={Link}
                 color={'text.primary'}
                 sx={{textDecoration: 'none'}}
                 onClick={(event: any) => event.stopPropagation()}
                 to={`/${getRoute('client')}/${v.clientId}`}>
          {getUserName(v)}
        </MuiLink>
      </Stack>
    ),
    sortKey: Field.FirstName
  },
  {
    title: 'Email',
    value: v => (
      <MuiLink component={Link}
               color={'text.primary'}
               sx={{textDecoration: 'none'}}
               onClick={(event: any) => event.stopPropagation()}
               to={`/${getRoute('client')}/${v.clientId}`}>
        {v.email}
      </MuiLink>
    ),
    sortKey: Field.Email
  },
  {
    title: 'Phone',
    value: v => formatToPhoneNumber(v.phoneNumber),
    sortKey: Field.PhoneNumber
  },
  {
    title: 'Tags',
    value: v => (
      <Box sx={{'& > div': {flexWrap: 'initial'} }}>
        <TagsView tags={v.tags} />
      </Box>
    )
  },
  {
    title: 'Birth Date',
    value: v => v.birthDate ? moment(v.birthDate, 'YYYY-MM-DD').format('L') : '',
    sortKey: Field.BirthDate
  },
  {
    title: 'Age',
    value: v => v.birthDate ? getAgeByBirthdate(v.birthDate, 'YYYY-MM-DD') : ''
  },
  {
    title: 'Most Recent Call',
    value: v => v.lastCallDate ? moment(v.lastCallDate).format('L H:mm') : ''
  },
  {
    title: 'Auth',
    value: v => v.userId ? <Check weight={'bold'} color={'green'} size={14} /> : <X weight={'bold'} color={'red'} size={14} />
  },
  {
    title: 'State',
    value: v => v.state
  },
  {
    title: 'Agent responsible',
    value: v => v.agentName
  },
  {
    title: 'Status',
    value: v => <StatusView status={v.status} />,
    sortKey: Field.Status
  },
  {
    title: 'Time since creation',
    value: v => (
      v.createdAt && v.status === StatusDto.NotYetEngaged ? <ClientListTimer createdAt={v.createdAt} /> : ''
    )
  },
  {
    title: 'Calls',
    value: v => v.callsCount
  },
  {
    title: 'Quote submitted timestamp',
    value: v => moment(v.createdAt).format('L H:mm'),
    sortKey: Field.CreatedAt
  },
  {
    title: 'Next contact date',
    value: v => v.followUpDate ? moment(v.followUpDate).format('L') : '',
    sortKey: Field.FollowUpDate
  },
  {
    title: 'Expected close date',
    value: v => v.expectedCloseDate ? moment(v.expectedCloseDate).format('L') : '',
    sortKey: Field.ExpectedCloseDate
  },
  {
    title: 'Lead Sources',
    value: v => v.affiliationPartnershipSource
  },
  {
    title: 'Profile Source',
    value: v => _.startCase(v.profileSource?.toLowerCase())
  }
]
